<template>
    <div class="flex justify-center flex-wrap mt-10 mb-8">
        <hr class="border-t border-slate-200 w-full" />
        <span
            class="inline-block px-2 relative tex-center text-slate-500 bg-white text-xs -mt-2.5"
        >
            or {{ action }} via email
        </span>
    </div>
</template>
<script setup>
defineProps({
    action: String,
});
</script>
